import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from 'react-immutable-proptypes';

import Component from "components/component";

export default class SizeOptionMobile extends Component {
  static propTypes = {
    handleClick: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
    optionValue: ImmutablePropTypes.map.isRequired,
    selectable: PropTypes.bool.isRequired
  };

  render() {
    const { optionValue, isSelected, handleClick, selectable } = this.props;
    const { id, displayName, optionType } = optionValue.toObject();
    let classSet = ["selection", "size-selection-mobile"];
    let onClick = handleClick.bind(this, id);

    if (isSelected) {
      classSet.push("selection-selected");
    }

    if (!selectable) {
      classSet.push("unselectable");
      onClick = null;
    }

    return (
      <div onClick={onClick} key={id} className={classSet.join(" ")}>
        <div className="selection-details">
          {displayName === "Custom" && <p>{displayName}</p>}

          {optionType === "Size" && <p>{displayName}</p>}

          {displayName !== "Custom" &&
            optionType !== "Size" && <p>{displayName}"</p>}
        </div>
      </div>
    );
  }
}
